import React from 'react';
import { Card } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import { renderLegends } from '../../../../support/SingleLeyendLabel';

import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';

const ComplementoDividendosResumen = ({ data = [], onEdit, onDelete, onListChange }) => {
  const handleOnDelete = () => {
    onDelete('Dividendos');
  }

  const handleOnEdit = () => {
    onEdit('Dividendos', data);
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Dividendos, Versión { data.Version }</Card.Subtitle>

        <Row className="mt-3 mb-4">
          <Col sm md="6" className="mb-2">
            { leftLabels.map(renderLegends(data)) }
          </Col>

          <Col sm md="6" className="mb-2">
          { rightLabels.map(renderLegends(data)) }
          </Col>
        </Row>

        <ComplementoSummaryActionButtons onEdit={ handleOnEdit} onDelete={ handleOnDelete } />
      </Card.Body>
    </Card>
  )
}
const leftLabels = [
  {
    label: 'Clave',
    index: 'DividOUtil.CveTipDivOUtil'
  },
  {
    label: 'Importe acreditado México',
    index: 'DividOUtil.MontISRAcredRetMexico'
  },
  {
    label: 'Importe acreditado Extranjero',
    index: 'DividOUtil.MontISRAcredRetExtranjero'
  },
  {
    label: 'Monto retención Extranjero',
    index: 'DividOUtil.MontRetExtDivExt'
  }
];

const rightLabels = [
  {
    label: 'Tipo Sociedad',
    index: 'DividOUtil.TipoSocDistrDiv'
  },
  {
    label: 'ISR acreditable nacional',
    index: 'DividOUtil.MontISRAcredNal'
  },
  {
    label: 'Monto acumulable nacional',
    index: 'DividOUtil.MontDivAcumNal'
  },
  {
    label: 'Monto acumulable extranjero',
    index: 'DividOUtil.MontDivAcumExt'
  },
  {
    label: 'Remanente',
    index: 'Remanente',
    render: (value, data) => value?.ProporcionRem || null
  },
];

export default ComplementoDividendosResumen
